/*global $, jQuery, alert, console*/

"use strict";
var users = [
    {
        name: "level_1",
        list: [
            {email:"affiliate@askgamblers.com",password:"TLsYPaO$d6"},{email:"bcatm20ftdlabs3@bettercollective.com",password:"$92BQxPL2c"},{email:"affiliate@inovatiq.com",password:"YP4xRAXVlk"},{email:"affiliate@scatter.info",password:"$jbopqlAYq"},{email:"info@joelssonmedia.com",password:"D#Q!2jyVTp"}
        ]
    },
    {
        name: "level_2",
        list: [
            {email:"business@britexagency.com",password:"loDJPYGnN^"},{email:"affiliates@casinopedia.org",password:"Z9GFKTvCsy"},{email:"accounts@gig.com",password:"L%k0&tp<hA"},{email:"neil8@mount-media.com",password:"3L7qev>bIg"},{email:"deals@spikeup.com",password:"%Fz<KZ)KtE"},{email:"pause@kafe.rocks",password:"pd6A*z3Pbb"},{email:"nathalie@ibexnetwork.com",password:"eY*jzBjaoR"}
        ]
    },
    {
        name: "level_3",
        list: [
            {
                email:"test-user3@test.com",
                password:"!Password!3"
            }
        ]
    },
    {
        name: "level_4",
        list: [
            {
                email:"test-user4@test.com",
                password:"!Password!4"
            }
        ]
    },
    {
        name: "level_5",
        list: [
            {
                email:"test-user5@test.com",
                password:"!Password!4"
            }
        ]
    }
]


$(document).ready(function () {
    var activeLevel = ''

    var formHistory = window.localStorage.getItem('bonusForm');

    if (formHistory == 'true') {
        $('.s-bonus__step').each(function () {
            $(this).removeClass('active');
            $('.s-bonus__step--4').addClass('active')
        })
    }

    $('#bonusCheckLogin').on('click', function (e) {
        e.preventDefault();
        var activeEmail = $('.s-bonus__login-form #contctEmail').val().toLowerCase();
        var activePassword = $('.s-bonus__login-form #contctCompanyPhone').val();

        var valid = false;

        users.forEach((item, index, array) => {
            item.list.forEach((dataMail) => {
                if (dataMail.email == activeEmail) {
                    if (dataMail.password == activePassword) {
                        activeLevel = item.name;
                        valid = true;
                    } else {
                        valid = false;
                    }
                }
            })
        })

        if (valid) {
            $('.s-bonus__step--1').removeClass('active')
            $('.s-bonus__login-form .form-error').addClass('hidden');
            $('.s-bonus__step--2').addClass('active');
            $('html, body').animate({
                scrollTop: $('.s-bonus__steps-wrap').offset().top - 120
            }, 500);
            $('.s-bonus__login-form .input-field').each(function () {
                $(this).removeClass('invalid')
            })
            $('.s-bonus__prizes-block').each(function () {
                $(this).removeClass('active');
                if ($(this).attr('data-level') == activeLevel) {
                    $(this).addClass('active');
                }
            })
        } else {
            $('.s-bonus__login-form .input-field').each(function () {
                $(this).addClass('invalid')
            })
            $('.s-bonus__login-form .form-error').removeClass('hidden');
        }

    })

    $('.s-bonus__next-btn').on('click', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('disabled')) {
            $('.s-bonus__step--2').removeClass('active');
            $('.s-bonus__step--3').addClass('active');
            $('html, body').animate({
                scrollTop: $('.s-bonus__steps-wrap').offset().top - 120
            }, 500);
        }
    })
    $('.s-bonus__prev-btn').on('click', function (e) {
        e.preventDefault();
        $('.s-bonus__step--2').addClass('active');
        $('.s-bonus__step--3').removeClass('active');
        $('html, body').animate({
            scrollTop: $('.s-bonus__steps-wrap').offset().top - 120
        }, 500);
    })

    $('.s-bonus__prize').on('click', function () {
        $('.s-bonus__prize').each(function () {
            $(this).removeClass('active');
        })
        $(this).addClass('active').closest('.s-bonus__prizes-block').addClass('valid').find('.s-bonus__next-btn').removeClass('disabled')

    })

    $('.s-bonus__prize-color').on('click', function () {
        $('.s-bonus__prize-color').each(function () {
            $(this).removeClass('active');
        })
        $(this).addClass('active');
    })
    $('.s-bonus__prize-btn').on('click', function () {
        $('.s-bonus__prize-btn').each(function () {
            $(this).removeClass('active');
        })
        $(this).addClass('active');
    })




});


